import {
  EXTERNAL_REFERRER_KEY,
  INTERNAL_REFERRER_KEY,
} from "./referrer.constants";

export const updateReferrer = (source) => {
  if (typeof window !== "undefined" && window.sessionStorage) {
    if (window.sessionStorage.getItem(EXTERNAL_REFERRER_KEY) === null) {
      window.sessionStorage.setItem(EXTERNAL_REFERRER_KEY, document.referrer);
    }
    if (typeof source !== "undefined") {
      window.sessionStorage.setItem(INTERNAL_REFERRER_KEY, source);
    }
  }
};

export const getExternalReferrer = () => {
  let externalReferrer = "direct";
  if (typeof window !== "undefined" && window.sessionStorage) {
    externalReferrer = window.sessionStorage.getItem(EXTERNAL_REFERRER_KEY);
    if (
      externalReferrer === null ||
      externalReferrer === "" ||
      externalReferrer?.indexOf("newsela.com") > -1
    ) {
      externalReferrer = "direct";
    }
  }
  return externalReferrer;
};

export const getInternalReferrer = () => {
  let internalReferrer = "";
  if (typeof window !== "undefined" && window.sessionStorage) {
    const internalReferrerValue = window.sessionStorage.getItem(
      INTERNAL_REFERRER_KEY,
    );
    if (internalReferrerValue !== null) {
      internalReferrer = internalReferrerValue;
    }
  }
  return internalReferrer;
};
